import { useState } from 'react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { homeFor, useAuth } from '../auth.jsx';
import AuthLayout from '../components/AuthLayout.jsx';
import Alert from '../components/ui/Alert.jsx';
import Field from '../components/Field.jsx';
import { checkEmail } from '../utils/validate.js';

/** Step 1: the email address. The API never says whether it has an account. */
export default function ForgotPassword() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState(location.state?.email || '');
  const [error, setError] = useState('');
  const [fieldError, setFieldError] = useState('');
  const [busy, setBusy] = useState(false);

  if (auth.user) return <Navigate to={homeFor(auth)} replace />;

  const submit = async (e) => {
    e.preventDefault();
    const clean = email.trim();
    const problem = checkEmail(clean, { label: 'your email address' });
    if (problem) { setFieldError(problem); return; }
    setBusy(true); setError('');
    try {
      const res = await auth.forgotPassword(clean);
      navigate('/reset-password', { state: { email: clean, resend_after: res.resend_after } });
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <AuthLayout onSubmit={submit}>
      <h1>Reset your password</h1>
      <p className="muted">Enter the email address you sign in with. We&rsquo;ll email you a 6-digit code to set a new password.</p>
      {error && <Alert tone="danger">{error}</Alert>}
      <Field label="Email address" type="email" autoComplete="email" autoCapitalize="none" required autoFocus value={email} error={fieldError}
        onChange={(e) => { setEmail(e.target.value); setError(''); setFieldError(''); }} />
      <button type="submit" className="btn btn-primary btn-block" disabled={busy}>{busy ? 'Sending…' : 'Email me a code'}</button>
      <p className="auth-switch"><Link to="/login">Back to sign in</Link></p>
    </AuthLayout>
  );
}
